import { styled } from 'styled-components';
import { Medium, UhcMedium, UhcRegular, UhcSans } from '../../apps/styles/common-style';

export const SetPaginationStyle = styled.div<{ padding?: string }>`
@import '../../../assets/scss/variables.scss';
@import '../../../assets/scss/main.scss';
.rlp-table-footer {
  padding: 10px 0;
  .rlp-right-section .page-number {
    width: 49px;
  }
  .pagination-btn-widget {
    .button-style,
    .button-style-blue {
      width: 40px;
    }
  }
}

.selectedItem {
  font-size: 16px;
  color: #2D2D39;
  font-family: ${UhcSans};
  line-height: 20px;
}
.rlp-table-footer {
  // display: inline-flex;
  height: 46px;
  padding: 0;
  padding: ${({ padding }) => padding ?? '16px 16px 20px 16px'};
  .rlp-left-section {
    display: inline-flex;
    align-items: flex-start;
    float: left;
    &-arrow-icon {
      position: relative;
      top: 8px;
      right: 100px;
      pointer-events: none;
      color: $strom-grey;
    }

    ::ng-deep .mat-form-field {
      padding-right: 8px;
      color: rgb(45, 45, 57);
      font-family: ${Medium};
      font-size: 16px;
      line-height: 22px;
    }

    ::ng-deep .mat-select-trigger {
      width: 52px;
      height: 40px;
      display: inline !important;
    }

    ::ng-deep .mat-form-field-underline {
      display: none;
    }

    ::ng-deep .mat-form-field-flex {
      padding: 0 !important;
    }

    ::ng-deep .mat-select {
      display: block;
      position: relative;
      flex: auto;
      min-width: 0;
      width: 71px;
      height: 40px;
      border: 1px solid rgb(205, 204, 220);
      text-align: center;
    }

    ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
      padding-bottom: 0;
    }

    ::ng-deep .mat-select-value {
      padding: 10px 9px 10px 12px;
      color: $black-rock;
      font-family: ${Medium};
      font-size: 16px;
      line-height: 22px;
      display: table !important;
    }

    ::ng-deep .mat-select-panel {
      min-width: 69 !important;
      box-shadow: none;
      border-radius: 0px !important;
    }

    ::ng-deep .mat-select-value-text {
      color: $black-rock;
      font-family: ${Medium};
      font-size: 16px;
      line-height: 22px;
    }
    ::ng-deep .mat-select-arrow-wrapper {
      visibility: hidden;
    }
  }
  .rlp-right-section {
    display: inline-flex;
    align-items: flex-end;
    float: right;
    .page-number {
      width: 66px;
      height: 40px;
      text-align: center;
      color: #2d2d39;
      font-family: ${UhcMedium};
      font-size: 16px;
      line-height: 20px;
      padding: 0;
      border:1px solid #B3BABC;
    }
    form {
      display: flex;
    }
    .ml-8 {
      margin-left: 8px;
    }
  }
  .pagination-btn-widget {
    padding-left: 8px;
    .button-style {
      background: transparent;
      margin: 0;
      vertical-align: middle;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      height: 44px;
      width: 56px;
      border: 1px solid #e0e0e0;
      border-radius: 2px;
      padding: 8px;
      box-sizing: border-box;
      color: #757588;
    }
    .button-style-blue {
      background: transparent;
      margin: 0;
      vertical-align: middle;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      height: 44px;
      width: 56px;
      border-radius: 2px;
      padding: 8px;
      box-sizing: border-box;
      border: 1px solid #196ecf;
      color: #196ecf;
    }
    .mr-18 {
      margin-right: 7px;
    }
  }
  .previous-button,
  .next-button {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }
  .rlp-footer-label {
    line-height: 20px;
    padding: 10px 8px 10px 6px;
    color: #757588;
    font-family: ${UhcRegular};
    font-size: 14px;
  }
}

`